import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";

import StatusCard from "components/cards/StatusCard";
import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import Loading from "components/App/Loading";
import Table from "components/Tables/Table";
import TableImage from "components/Tables/TableImage";
import Filters from "components/dashboard/Filters";
import { getState } from "state/selector";
import { GlassCard, CardsContainer } from "components/App/styled";
import { updateUser } from "state/actions";

function Index(props) {
  console.log("store redux", props.store);
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    Fetch.get("/status", (res) => {
      if (res) {
        console.log(res);

        setData(res);
      }
      console.log("status", res);
    });
    setReload(false);
  }, [reload]);

  function handleUpdate(index) {
    setUpdateModal(products[index]);
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <CardsContainer>
        <StatusCard
          color={"#ade28f"}
          textColor="#444"
          value={data?.active_orders || 0}
          text="سفارش های فعال"
          link="orders"
        />
        <StatusCard
          color="#E8E8E8"
          textColor="#444"
          value={data?.products}
          text="محصولات"
          link="products"
        />
        <StatusCard
          color="#048A81"
          textColor="#fff"
          value={data?.active_comments || 0}
          text="نظرات تایید نشده"
          link="comments"
        />
        <StatusCard
          color={colors.secondary}
          textColor="#444"
          value={data?.todayVisits || 0}
          text="بازدید‌های امروز"
          link=""
        />
        <StatusCard
          color="#3A4041"
          textColor="#fff"
          value={data?.monthlyVisit || 0}
          text="بازدید‌های این ماه"
          link=""
        />
        <StatusCard
          color="#61a751"
          textColor="#ffffff"
          value={(data?.smsCount && JSON.parse(data?.smsCount)?.amount) || "-"}
          text="پیامک های باقیمانده"
          link="https://login.melipayamak.com/"
        />
      </CardsContainer>

      {/* <TableContainer>
        <GlassCard
          style={{ padding: "9px 5px 0 5px", width: 178, marginBottom: 8 }}
        >
          <Typography.Title level={4} style={{ opacity: 0.7 }}>
            سفارش های فعال
          </Typography.Title>
        </GlassCard>
        <Table
          loading={reload}
          columns={tableHeaders}
          dataSource={products.map((item, index) => ({
            ...item,
            image: <TableImage data={JSON.parse(item.data).images} />,
            actions: (
              <div className="row">
                <Button onClick={() => handleUpdate(index)}>
                  <EditOutlined />
                </Button>
                <DeleteButton
                  id={item.id}
                  reload={setReload}
                  title="کالا"
                  link="products"
                />
              </div>
            ),
            key: index + 1,
          }))}
        />
      </TableContainer> */}
    </>
  );
}
const mapStateToProps = (state) => {
  const store = getState(state);
  return { store };
};
export default connect(mapStateToProps, { updateUser })(Index);

const TableContainer = styled.div`
  margin-top: 48px;
  margin-bottom: 48px;
`;

const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  {
    title: "تصویر",
    dataIndex: "image",
    key: "image",
    align: "center",

    width: "80px",
  },
  {
    title: "نام کالا",
    dataIndex: "title",
    key: "title",
    align: "center",

    width: "100px",
    ellipsis: true,
  },
  {
    title: "دسته بندی",
    dataIndex: "category",
    key: "category",
    align: "center",

    width: "80px",
  },
  {
    title: "برند",
    dataIndex: "brand",
    key: "brand",
    align: "center",

    width: "80px",
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    align: "center",
    ellipsis: true,

    width: "80px",
  },
  {
    title: "موجودی",
    dataIndex: "stock",
    key: "stock",
    align: "center",
    width: "80px",
  },
  {
    title: "قیمت",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: "80px",
  },
  {
    title: "اعمال",
    dataIndex: "actions",
    key: "actions",
    align: "center",
    width: "80px",
  },
];
